var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grey lighten-4 text-right pa-4"},[_c('span',{staticClass:"mx-4"},[_vm._v("Tổng tiền chi trả")]),(!_vm.loadingFee)?_c('span',{staticClass:"red--text mx-4"},[_vm._v(" "+_vm._s(_vm.totalFee ? _vm.totalFee.toLocaleString('en-US') : 0)+" VNĐ ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }